import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { ConfigService } from 'src/app/core/service/config.service';
import { ApiUserService } from '../../../core/service/api-user.service';
import { ChangeImageComponent } from '../change-image/change-image.component';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-change-phone',
  templateUrl: './change-phone.component.html',
  styles: [
  ]
})
export class ChangePhoneComponent implements OnInit {
  @HostListener('window:resize', ['$event'])

  Step: 1 | 2 = 1
  loading: boolean = false
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO: any = CountryISO.SaudiArabia;
  PhoneNumberFormat = PhoneNumberFormat;
  formSubmitAttempt: boolean = false;
  phoneModal: any
  firstFormGroup = this._formBuilder.group({
    phone: ['', [Validators.required, Validators.maxLength(20)]],
  });
  secondFormGroup = this._formBuilder.group({
    otp: ['', Validators.required],
  });
  getScreenWidth: number = window.innerWidth;

  constructor(private _config: ConfigService,
    private _formBuilder: FormBuilder,
    private apiUserService: ApiUserService,
    public dialogRef: MatDialogRef<ChangeImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string) { }

  ngOnInit() {

  }

  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  goForward(stepper: MatStepper) {
    stepper.next();
  }

  SubmitPhone(stepper: MatStepper) {
    if (this.firstFormGroup.valid) {
      this.loading = true;
      let phone: any = this.firstFormGroup.value?.phone
      this.phoneModal = { phone: phone?.number?.replaceAll(/\s/g, ''), phone_code: phone?.countryCode, e164Number: phone?.e164Number }
      this.apiUserService.SendOtpToUpdatePhone(this.phoneModal, this.data).subscribe(
        (res: any) => {
          this.loading = false;
          this._config.toastrService.success(this._config.translate.instant("users.Check your phone please!"))
          stepper.next();
          this.Step = 2
        },
        (error: any) => {
          this.loading = false;
          this._config.showErrors(error)
        }
      )
    }
  }

  SubmitOTP(stepper: MatStepper) {

    if (this.firstFormGroup.valid) {
      this.loading = true;
      let modal = { ...this.phoneModal, ... this.secondFormGroup.value }

      this.apiUserService.UpdatePhone(modal, this.data).subscribe(
        (res: any) => {

          this.loading = false;
          this._config.toastrService.success(this._config.translate.instant("users.Phone updated successfully"))
          stepper.next();
          this.dialogRef.close("success")
        },
        (error: any) => {

          this.loading = false;
          this._config.showErrors(error)
        }
      )
    }

  }



  hasError(GroupName: FormGroup, controlName: string, errorName: string) {
    return GroupName.controls[controlName].hasError(errorName);
  }

  onWindowResize(event: any) {
    this.getScreenWidth = event.target.innerWidth;
  }
}
